export default {"src":"/_next/static/media/checkbox-checked.7e7bd052.svg","height":20,"width":20};